<script setup>
// Page title row for pages that aren't a single card (dashboards): title,
// muted subtitle, actions on the right.
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
});
</script>

<template>
  <header class="ui-page-header">
    <div class="ui-page-header__text">
      <h1 class="ui-page-header__title">{{ title }}</h1>
      <p v-if="subtitle" class="ui-page-header__subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="ui-page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<style scoped>
.ui-page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}
.ui-page-header__text {
  min-width: 0;
}
.ui-page-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--foreground);
}
.ui-page-header__subtitle {
  margin: 2px 0 0;
  font-size: 14px;
  color: var(--muted-foreground);
}
.ui-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
